(function () {
  'use strict';

  function initializeClubAdhekForm() {
    var form = document.getElementById('ca-club-form');

    if (!form || form.dataset.initialized === 'true') {
      return;
    }

    form.dataset.initialized = 'true';

    var button = document.getElementById('ca-submit-button');
    var formContainer = document.getElementById('ca-form-container');
    var successMessage = document.getElementById('ca-success');
    var errorMessage = document.getElementById('ca-error');

    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        return;
      }

      if (button) {
        button.disabled = true;
        button.textContent = 'Registrando...';
        button.setAttribute('aria-busy', 'true');
      }

      if (errorMessage) {
        errorMessage.hidden = true;
      }

      /*
       * No usamos preventDefault().
       * El navegador debe enviar el formulario normalmente
       * al iframe oculto configurado en target.
       */

      window.requestAnimationFrame(function () {
        if (formContainer) {
          formContainer.hidden = true;
        }

        if (successMessage) {
          successMessage.hidden = false;
          successMessage.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeClubAdhekForm
    );
  } else {
    initializeClubAdhekForm();
  }
})();